<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { required, email } from '@validations';
import axios from '@/libs/axios';

export default {
  components: {
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        workflowid: '',
        workflowiddestino: '',
      }),
      require: true,
    },
    titleModal: {
      type: String,
      default: null,
      require: false,
    },
    idModal: {
      type: String,
      default: null,
      require: false,
    },
    labelBtnOk: {
      type: String,
      default: null,
      require: false,
    },
  },
  data() {
    return {
      dataFromApiWorkflow: null,
      dataFromApiWorkflowTipo: null,
      workflowtipoid: null,
    };
  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    async validateForm() {
      this.$emit('ok', this.dataForm);
      this.$bvModal.hide(this.idModal);
    },
    async fetchDataFromWorkflow() {
      try {
        const response = await axios.get(`/workflow/findByTipoWorkflow/${this.workflowtipoid}`);
        this.dataFromApiWorkflow = response.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async resetform() {
      this.workflowtipoid = null;
    },
    async fetchDataFromWorkflowTipo() {
      try {
        const response = await axios.get('/workflow-tipo');
        this.dataFromApiWorkflowTipo = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    onModalShow() {
      this.fetchDataFromWorkflowTipo();
    },
  },

};
</script>

<template>
  <b-modal
      no-close-on-backdrop
      no-close-on-esc
      size="md"
      :id="idModal"
      :title="titleModal"
      :ok-disabled="dataForm.isDefault || dataForm.workflowiddestino === ''"
      :ok-title="labelBtnOk"
      ok-variant="success"
      cancel-variant="secondary"
      body-bg-variant="light"
      cancel-title="Cancelar"
      @ok="validateForm();resetform()"
      @cancel="$emit('cancel');resetform()"
      @close="$emit('cancel')"
      @show="onModalShow"
  >
    <validation-observer ref="refFormData">
      <b-form @submit.prevent>
        <b-row>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Tipo Workflow"
                label-for="workflowid"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >

              <b-form-select
                  v-model="workflowtipoid"
                  id="workflowtipoid"
                  :state="errors.length > 0 ? false : null"
                  :options="dataFromApiWorkflowTipo"
                  value-field="workflowtipoid"
                  text-field="workflowtipodescricao"
                  placeholder="Selecione uma workflow tipo"
                  @change="fetchDataFromWorkflow()"
                  :disabled="!dataFromApiWorkflowTipo"
              />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Workflow"
                label-for="workflowid"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >

              <b-form-select
                  v-model="dataForm.workflowid"
                  id="workflowid"
                  :state="errors.length > 0 ? false : null"
                  :options="dataFromApiWorkflow"
                  value-field="workflowid"
                  text-field="workflowdescricao"
                  placeholder="Selecione uma workflow"
                  :disabled="workflowtipoid === null || !dataFromApiWorkflow"
              />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Workflow Destino"
                label-for="workflowiddestino"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
              <b-form-select
                  v-model="dataForm.workflowiddestino"
                  id="workflowiddestino"
                  :state="errors.length > 0 ? false : null"
                  :options="dataFromApiWorkflow"
                  value-field="workflowid"
                  text-field="workflowdescricao"
                  placeholder="Selecione uma destino"
                  :disabled="workflowtipoid === null || !dataFromApiWorkflow"
              />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>
